module.exports = __webpack_public_path__ + "static/blue-6b4c55d2b0a103f51e3eab13f7859ad8.jpeg";